import { useState } from "react"
import { useFetch } from "../../../hooks/useFetch"
import { deleteDocumentAdminService } from "../services/deleteDocumentAdmin.service"
import { updateDocumentAdminService } from "../services/updateDocumentAdmin.service"

export const useDocumentsAdminCommand = (refresh) => {
  const fetchData = useFetch()
  const [loading, setLoading] = useState(false)

  const editFile = async ({ document, file }) => {
    try {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', file)
      const response = await updateDocumentAdminService(fetchData)({ document, file: formData })
      refresh?.()
      return response
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const deleteFile = async ({ document }) => {
    try {
      setLoading(true)
      const response = await deleteDocumentAdminService(fetchData)(document)
      refresh?.()
      return response
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    editFile,
    deleteFile,
    loading
  }
}
